import styled from "@emotion/styled";
import { Trans, useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";
import LikeIcon from "src/images/Icons/newIcons/notifications/like.svg";

import newApi from "../../../newApi";
import { TimeComponent } from "../../NewComponents/Default/TimeComponent";
import type { NotificationData } from "./List";
import { Notification } from "./NotificationItem";

interface CommentLikeProps {
	notification: NotificationData;
	removeNotification: () => Promise<unknown>;
	className?: string;
}

function CommentLike({
	notification,
	removeNotification,
	className,
}: CommentLikeProps) {
	const { openModal } = useModals();
	const { t } = useTranslation();

	const redirect = async () => {
		try {
			const comment = await newApi.getComment(notification.itemId);
			if (!comment) {
				throw new Error();
			}

			if (comment.type === "FORUM") {
				openModal(ModalsNames.ForumQuestionAnswerModal, {
					parentId: comment.parentId,
				});
			} else {
				openModal(ModalsNames.QuestionViewModal, {
					questionId: comment.questionId,
					settings: {
						comments: comment.questionId,
					},
				});
			}
		} catch (_error) {
			toast.error(t("errors.commentNotFound"), {
				position: toast.POSITION.BOTTOM_LEFT,
				pauseOnHover: false,
				autoClose: 5000,
			});
		}
	};

	return (
		<Notification
			className={className}
			notification={notification}
			removeNotification={removeNotification}
			onRedirect={redirect}
			Icon={LikeIcon}
			Primary={
				<Trans
					i18nKey="notifications.commentLike.title"
					values={{ username: notification.username }}
					components={[<strong className="text-black" key="i18Key" />]}
				/>
			}
			Secondary={
				<div className="text-primary size-12 mt-2">
					<TimeComponent
						date={notification.createdAt}
						transKey="notifications.comment.days"
					/>
				</div>
			}
		/>
	);
}

export const CommentLikeNotification = styled(CommentLike)``;
